import { Accordion as AccordionPrimitive } from '@base-ui/react/accordion';

import { Icon } from '../icon';
import { cn } from '../../lib/utils';

function Accordion({ className, ...props }: AccordionPrimitive.Root.Props) {
  return (
    <AccordionPrimitive.Root
      data-slot={'accordion'}
      className={cn('flex w-full flex-col gap-4', className)}
      {...props}
    />
  );
}

function AccordionItem({ className, ...props }: AccordionPrimitive.Item.Props) {
  return (
    <AccordionPrimitive.Item
      data-slot={'accordion-item'}
      className={cn(
        'bg-neutral overflow-hidden rounded-xl border border-neutral-border data-[open]:bg-neutral',
        className
      )}
      {...props}
    />
  );
}

function AccordionTrigger({
  className,
  children,
  ...props
}: AccordionPrimitive.Trigger.Props) {
  return (
    <AccordionPrimitive.Header className={'flex m-0'}>
      <AccordionPrimitive.Trigger
        data-slot={'accordion-trigger'}
        className={cn(
          '[&_[data-slot=accordion-trigger-icon]]:text-muted-foreground bg-neutral-50 gap-6 p-4 text-primary text-left text-lg font-bold [&_[data-slot=accordion-trigger-icon]]:ml-auto [&_[data-slot=accordion-trigger-icon]]:size-4 group/accordion-trigger relative flex flex-1 items-start justify-between transition-all outline-none hover:cursor-pointer disabled:pointer-events-none disabled:opacity-50',
          className
        )}
        {...props}
      >
        {children}
        <Icon
          data-slot={'accordion-trigger-icon'}
          name={'chevron-down'}
          className={
            'pointer-events-none size-5 shrink-0 group-aria-expanded/accordion-trigger:hidden'
          }
        />
        <Icon
          data-slot={'accordion-trigger-icon'}
          name={'chevron-up'}
          className={
            'pointer-events-none size-5 hidden shrink-0 group-aria-expanded/accordion-trigger:inline'
          }
        />
      </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
  );
}

function AccordionContent({
  className,
  children,
  ...props
}: AccordionPrimitive.Panel.Props) {
  return (
    <AccordionPrimitive.Panel
      data-slot={'accordion-content'}
      className={
        'data-[open]:animate-accordion-down data-[closed]:animate-accordion-up px-4 text-sm overflow-hidden'
      }
      {...props}
    >
      <div
        className={cn(
          'pt-0 pb-4 [&_a]:hover:text-foreground h-[var(--accordion-panel-height)] data-[ending-style]:h-0 data-[starting-style]:h-0 [&_a]:underline [&_a]:underline-offset-3 [&_p:not(:last-child)]:mb-4',
          className
        )}
      >
        {children}
      </div>
    </AccordionPrimitive.Panel>
  );
}

export { Accordion, AccordionContent, AccordionItem, AccordionTrigger };
